import React, { PureComponent } from 'react'
import { get } from 'lodash'
import FixedImg from './FixedImg'
import Dotdotdot from './MagikDotDotDot'
import Card, { CardActions, CardContent } from 'material-ui-next/Card'
import Button from 'material-ui-next/Button'
import Typography from 'material-ui-next/Typography'
import withStyles from 'material-ui-next/styles/withStyles'
import classNames from 'classnames'

const LISTCARD_HEIGHT = 140
const MOBILE_LISTCARD_HEIGHT = 320

const styles = theme => ({
  padding5: {
    padding: 5,
  },
  card: {
    height: LISTCARD_HEIGHT,
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    minWidth: '100%',
  },
  cardPoiner: {
    cursor: 'pointer',
  },
  categoryLabel: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#BDBDBD',
    marginBottom: 10,
  },
  titleStyle: {
    wordBreak: 'keep-all',
    fontWeight: 'bold',
    fontSize: 18,
    lineHeight: '20px',
    color: theme.swapick.colors.positive,
  },
  content: {
    flex: '1',
    paddingLeft: 20,
    paddingRight: 100,
  },
  mediaStyle: {
    width: LISTCARD_HEIGHT,
  },
  text: {
    color: 'rgba(0, 0, 0, 0.54)',
    wordBreak: 'keep-all',
    fontSize: 14,
  },
  user: {
    color: theme.swapick.colors.positive,
  },
  btn: {
    position: 'absolute',
    right: 0,
  },
  '@media (max-width: 992px)': {
    card: {
      height: MOBILE_LISTCARD_HEIGHT,
      flexDirection: 'column',
    },
    mediaStyle: {
      width: '100%',
      margin: 'auto',
      paddingTop: 16,
    },
    titleStyle: {
      fontSize: 16,
    },
    btn: {
      bottom: 5,
    },
  },
})

class ListCard extends PureComponent {
  handleClick = () => {
    this.props.onClick(this.props.item, this.props.index)
  }

  render() {
    const {
      item,
      showPosseduto = false,
      onClick,
      rightButton,
      classes,
    } = this.props
    return (
      <div className={classes.padding5}>
        <Card
          className={classNames(classes.card, {
            [classes.cardPoiner]: !!onClick,
          })}
          onClick={onClick ? this.handleClick : undefined}>
          <div className={classes.mediaStyle}>
            <FixedImg src={item.immagine} height={140} />
          </div>
          <CardContent className={classes.content}>
            <Typography
              type="headline"
              component="h2"
              className={classes.titleStyle}>
              <Dotdotdot clamp={2}>{item.titolo}</Dotdotdot>
            </Typography>
            <Typography
              component={'div'}
              type="body1"
              className={classes.text}
              paragraph>
              <Dotdotdot clamp={4}>
                <div>
                  <div className={classes.categoryLabel}>
                    {item.categoria.nome}
                  </div>
                  <div>{get(item, 'attributi[0].valore')}</div>
                  <div>{get(item, 'attributi[1].valore')}</div>
                  {item.posseduto_da &&
                    item.posseduto_da.length > 0 &&
                    showPosseduto &&
                    <div>
                      {'di '}
                      <strong className={classes.user}>
                        {item.posseduto_da[0].user.username ||
                          item.posseduto_da[0].user.nome}
                      </strong>
                    </div>}
                </div>
              </Dotdotdot>
            </Typography>
          </CardContent>
          <CardActions className={classes.btn}>
            {rightButton}
          </CardActions>
        </Card>
      </div>
    )
  }
}

export default withStyles(styles)(ListCard)



// WEBPACK FOOTER //
// ./src/common/ListCard.js